import { KngBannerState } from './definitions';
export class KngBannerFactory 
{
	public static buildState(): KngBannerState 
	{
		return {
			bannerIcon: {
				iconPath: '',
				altText: ''
			},
			bannerMessage: '',
			tokenData: [
				{
					label: '',
					value: '',
					href: ''
				}
			],
			closeIcon: {
				iconPath: '',
				altText: ''
			},
			open: false,
			startDate: new Date('2005-12-31T23:59:59.999Z'),
			endDate: new Date('2050-12-31T23:59:59.999Z')
		};
	}
}
